var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0007 18.3333H38.334V16.6667C38.334 13.8333 36.1673 11.6667 33.334 11.6667H26.6673C23.834 11.6667 21.6673 13.8333 21.6673 16.6667V18.3333H15.0007C14.0007 18.3333 13.334 19 13.334 20C13.334 21 14.0007 21.6667 15.0007 21.6667H16.6673V43.3333C16.6673 46.1667 18.834 48.3333 21.6673 48.3333H38.334C41.1673 48.3333 43.334 46.1667 43.334 43.3333V21.6667H45.0007C46.0007 21.6667 46.6673 21 46.6673 20C46.6673 19 46.0007 18.3333 45.0007 18.3333ZM25.0006 16.6667C25.0006 15.6667 25.6673 15 26.6673 15H33.334C34.334 15 35.0006 15.6667 35.0006 16.6667V18.3333H25.0006V16.6667ZM38.334 45C39.334 45 40.0006 44.3333 40.0006 43.3333V21.6667H20.0006V43.3333C20.0006 44.3333 20.6673 45 21.6673 45H38.334ZM28.334 28.3333V38.3333C28.334 39.3333 27.6673 40 26.6673 40C25.6673 40 25.0006 39.3333 25.0006 38.3333V28.3333C25.0006 27.3333 25.6673 26.6667 26.6673 26.6667C27.6673 26.6667 28.334 27.3333 28.334 28.3333ZM35.0007 38.3333V28.3333C35.0007 27.3333 34.334 26.6667 33.334 26.6667C32.334 26.6667 31.6673 27.3333 31.6673 28.3333V38.3333C31.6673 39.3333 32.334 40 33.334 40C34.334 40 35.0007 39.3333 35.0007 38.3333Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCircle);
export default __webpack_public_path__ + "static/media/trash-circle.6b7c8e8c2a473984dad302d649e054fe.svg";
export { ForwardRef as ReactComponent };